import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartData } from 'src/app/models/cartData.model';
import { Product } from 'src/app/models/product.model';
import { CartService } from 'src/app/services/cart.service';
import { RequestModel } from 'src/app/typings/typing';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-order-failed',
  templateUrl: './order-failed.component.html',
  styleUrls: ['./order-failed.component.less']
})
export class OrderFailedComponent implements OnInit {
  productList:any[]=[];
  asyncOrderResultId:string='';
  cartData!: CartData;
  errorMessages:any[]=[];
  country:string | null = localStorage.getItem('country');
  addressError: boolean = false; //Address Error
  showType: any = {
    warning: [
      '007','008','012','013','005','006','030','031','033','034','037','023'
    ],
    error: [
      '002','003','004','009','010','011','017','021','022','025','026','027','042','043','039','018','019','028','029','020', '024'
    ],
    product_warning:['007','008'],
    qty_warning: ['012','013'],
    discount_warning:['005','006','030','031','033','034','037','023'],
    date_error: ['020', '024'],
    qty_error: ['018','019','028','029'],
    invalid_error: ['002','003','004','009','010','011','017','021','022','025','026','027','042','043','039'],//加上不能识别的error
    toast: ['084', '083'],
    address: ['044'],
  };
  warningCategory: any = {
    product_warning:['007','008'],
    qty_warning: ['012','013'],
    discount_warning:['005','006','030','031','033','034','037','023'],
  };
  salesOffice = '';
  constructor(private router: Router, private route: ActivatedRoute, private cartService: CartService,
    private customerService: CustomerService) {
    this.customerService.selectedCustomer$.subscribe((customer) => {
      this.salesOffice = customer?.salesOffice || '';;
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params=>{
      this.asyncOrderResultId = params['asyncOrderResultId'];
      this.getInfoByResultId();
    })
  }

  getMessageByPromotion(messages: { code: string; message: string; severity: string }[]): string[]{
    return messages
    .filter(msg => this.warningCategory.discount_warning.includes(msg.code))
    .map(msg => msg.message);
  }

  getMessagesExcludingPromotion(messages: { code: string; message: string; severity: string }[]): { code: string; message: string; severity: string }[] {
    return messages
    .filter(msg => !this.warningCategory.discount_warning.includes(msg.code));
  }

  getMessagesByType(errors:any[],type:string,category?:string):string[]{
    if(!Array.isArray(errors)){
      return [];
    }
    if(category){
      return errors.filter(error => {
        return this.warningCategory[category].includes(error.code);
        }).map(filteredError => {
            return filteredError.message;
        });
    }
    let filteredErrors = errors?.filter(error => error.severity === type);
    return filteredErrors?.map(error => error.message);
  }

  //Obtain errorType based on errorMessages
  getErrorMessageTypes(errors: any[]): string[] {
    const allErrorTypes: string[] = [];
    for (const error of errors) {
      let found = false;
      for (const type in this.showType) {
        if (this.showType.hasOwnProperty(type)) {
          const typeErrorCodes = this.showType[type];

          if (typeErrorCodes.includes(error.code.toString())) {
            if (!allErrorTypes.includes(type)) {
              allErrorTypes.push(type);
            }
            error.errorType = type;
            found = true;
            continue;
          }
        }
      }
      if (!found) {
        // Add default type
        let errorType = error.severity=='W'?'warning':'error';
        error.errorType = errorType; 
        allErrorTypes.push(errorType); 
      }
    }
    return [...new Set(allErrorTypes)];
  }
  isInPromotion(item: any): boolean {
    return (
      item?.components?.length > 0 &&
      item.components.every((c: any) => c.isGift) &&
      item?.isSimulated
    );
  }

  isOesCountry(): boolean {
    const currentCountry = (localStorage.getItem('country') || '').trim().toLowerCase();
    const componentCountry = (this.country || '').trim().toLowerCase();
    const pathName = window.location.pathname.toLowerCase();
    return [currentCountry, componentCountry].includes('/oes') ||
      [currentCountry, componentCountry].includes('oes') ||
      pathName.includes('/oes');
  }

  getMaxDeliveryDate(deliveryInfoList: any[]): string {
    if (!Array.isArray(deliveryInfoList) || deliveryInfoList.length === 0) {
      return '';
    }

    return deliveryInfoList
      .map(deliveryInfo => deliveryInfo?.deliveryDate)
      .filter(Boolean)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .pop() || '';
  }

  getDeliveryInfoListForDisplay(deliveryInfoList: any[]): any[] {
    if (!this.isOesCountry()) {
      return deliveryInfoList;
    }

    const maxDeliveryDate = this.getMaxDeliveryDate(deliveryInfoList);
    return maxDeliveryDate ? [{ deliveryDate: maxDeliveryDate }] : [];
  }

  shouldShowDeliveryQuantity(): boolean {
    return !this.isOesCountry();
  }

  getInfoByResultId():void{
    this.cartService.getInfoByResultId({id:this.asyncOrderResultId}).subscribe(( result:any)=>{
      this.cartData = result.rtnData;
      this.productList = this.cartData.list.map((product: any) => {
        const errorTypes = this.getErrorMessageTypes(product.errorMessages);
        return { ...product, errorTypes: errorTypes};
      });
      this.errorMessages=this.cartData.errorMessage.filter((i:any)=>i.severity=='E');
      this.addressError = this.cartData.errorMessage.some(
        (error: any) => error.code == '044'
      );
    })
  }
  
  async reOrder(list:any[]):Promise<void>{
    //go to cart
    let products:Product[] = list.map(item=>{
      return {
        inputMaterialNumber:item.inputMaterialNumber,
        expectedDate: item.expectedDate,
        quantity: item.quantity
      };
    })
    await this.cartService.addToCart(products).then(()=>{
      const country = localStorage.getItem("country");
      this.router.navigateByUrl(`${country}/cart`);
    });
  }

}
